export const headers = () => ({
  Token: localStorage.getItem("token"),
});
